import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import FareRulesDrawerWeb from "./layouts/FareRulesDrawer.web";
import FareRulesDrawerMob from "./layouts/FareRulesDrawer.mob";

const FareRulesDrawerComponent = withConditionalComponent(FareRulesDrawerWeb, FareRulesDrawerMob);

export default function FareRulesDrawer() {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <FareRulesDrawerComponent trigger={isLargeScreen} />;
}
